<template>
  <div class="page-container">
    <el-form
      :inline="true"
      class="demo-form-inline toolbar"
      style="padding-bottom: 0px"
    >
      <el-form-item>
        <kt-button icon="" label="返回" type="primary" @click="goBack()" />
      </el-form-item>
    </el-form>
    <div class="content" v-loading="loading" element-loading-text="拼命加载中">
      <table v-loading="loading" element-loading-text="拼命加载中">
        <thead></thead>
        <tbody>
          <tr style="height: 60px; text-align: left">
            <td
              colspan="6"
              style="text-indent: 15px; font-size: 16px; font-weight: 600"
              width="90%"
            >
              礼品详情
            </td>
            <td
              rowspan="3"
              style="font-size: 14px; font-weight: 600; text-align: center"
              width="10%"
            >
              <img
                :src="dataInfo.giftPic"
                alt=""
                preview="1"
                style="width: 95%; height: 150px; vertical-align: middle"
              />
            </td>
          </tr>
          <tr style="height: 50px; text-align: center">
            <td width="15%" style="font-size: 14px; font-weight: 600">
              礼品编号
            </td>
            <td width="15%">{{ dataInfo.giftNo }}</td>
            <td width="15%" style="font-size: 14px; font-weight: 600">
              礼品名称
            </td>
            <td width="15%">{{ dataInfo.giftName }}</td>
            <td width="15%" style="font-size: 14px; font-weight: 600">
              礼品价格
            </td>
            <td width="15%">{{ dataInfo.price }}</td>
          </tr>
          <tr style="height: 50px; text-align: center">
            <td width="15%" style="font-size: 14px; font-weight: 600">积分</td>
            <td width="15%">{{ dataInfo.integral }}</td>
            <td width="15%" style="font-size: 14px; font-weight: 600">库存</td>
            <td width="15%">{{ dataInfo.stock }}</td>
            <td width="15%" style="font-size: 14px; font-weight: 600">
              是否上架
            </td>
            <td width="15%">{{ dataInfo.shelf }}</td>
          </tr>
          <tr style="height: 50px; text-align: center">
            <td style="font-size: 14px; font-weight: 600">开始时间</td>
            <td>{{ dataInfo.periodStart }}</td>
            <td style="font-size: 14px; font-weight: 600">结束时间</td>
            <td>{{ dataInfo.periodEnd }}</td>
            <td style="font-size: 14px; font-weight: 600">是否发货</td>
            <td colspan="2">{{ dataInfo.send }}</td>
          </tr>
        </tbody>
        <tfoot></tfoot>
      </table>
      <div class="gift_describe">
        <div class="gift_describe_text">
          <div>礼品描述</div>
        </div>
        <div class="gift_describe_content" v-html="dataInfo.remark">
          {{ dataInfo.remark }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
export default {
  components: { KtButton },
  data() {
    return {
      loading: true,
      id: "",
      avatar: "",
      //传给子组件的值
      dataInfo: {},
    };
  },
  methods: {
    goBack() {
      console.log("返回上层");
      bus.$emit('close_current_tags');
    },
    getGiftRecordDetail() {
      let params = {
        pageNum: 0,
        pageSize: 0,
      };
      this.id = this.$route.query.id;
      this.$postJson("omc/gift/queryListWithPage", this.params).then((res) => {
        console.log(res.result);
        res.result.list.forEach((item) => {
          console.log(item + "-----------");
          item.shelf == 0 ? (item.shelf = "否") : (item.shelf = "是");
          item.send == 0 ? (item.send = "否") : (item.send = "是");
          if (this.id == item.id) {
            this.dataInfo = item;
            return;
          }
        });
        console.log(this.dataInfo);
        let giftPicId = this.dataInfo.giftPic;
        this.getImgInfo(giftPicId);
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
    },
    //图片的回显
    getImgInfo(infoData) {
      let id = infoData;
      console.log(id);
      if (id) {
        this.$postForm("opc/file/queryAttachmentById/" + id).then((res) => {
          console.log(res);
          var path = res.result.path;
          var name = res.result.name;
          this.avatar = "http://51cs8.com/" + path + name;
          this.dataInfo.giftPic = this.avatar;
        });
      }
    },
  },
  mounted() {
    this.getGiftRecordDetail();
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  height: 500px;
  display: flex;
  flex-direction: column;
  background: #fff;
  .demo-form-inline {
    height: 50px;
    line-height: 50px;
  }
  .content {
    width: 99%;
    flex: 1;
    background: #fff;
    table {
      width: 100%;
      margin: 10px 5px 0 5px;
      border-collapse: collapse;
      border: 1px solid #cccccc;
      td {
        border: 1px solid #cccccc;
      }
    }
    .gift_describe {
      margin: 0 5px 30px 5px;
      width: 99.8%;
      height: 300px;
      border: 1px solid #cccccc;
      border-top: none;
      display: flex;
      .gift_describe_text {
        width: 138px;
        height: 100%;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        border-right: 1px solid #cccccc;
        div {
          margin-top: 15px;
        }
      }
      .gift_describe_content {
        flex: 1;
        height: 100%;
        overflow-y: scroll;
        overflow-x: scroll;
      }
    }
  }
}
</style>
